import React, { useEffect, useState } from 'react'
import { getAboutUsPageData } from '../../../services/cmsPage.service';
import "./style.scss";

interface AboutItem {
    id: string;
    content: string;
}

const AboutUs = () => {
    const [aboutData, setAboutData] = useState<AboutItem[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getAboutUsPageData();
                setAboutData(Array.isArray(response) ? response : []);
                setLoading(false);
            }
            catch (error: any) {
                console.error("Error fetching data:", error);
                setError(error?.message ?? "Failed to load content");
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    // Helper: find item by id (returns undefined if not present)
    const findById = (id: string) => aboutData?.find((i: any) => i?.id === id);
    const aboutUsContent = findById("1");      // left column
    const missionContent = findById("2");      // mission text
    const renderHtml = (html: string) => ({ __html: html });



    return (
        <div>
            <>
                {/* ==================== BANNER ==================== */}
                <section className="banner-section">
                    <div className="container">
                        <div className="row ">
                            <div className="col-md-12 ">
                                <div className="main-heading d-flex justify-content-center align-items-center">
                                    <h1 className="hero-title">About Us</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* ==================== LOADING BELOW BANNER ==================== */}
                {loading ? (
                    <section className="py-5 bg-light">
                        <div className="container">
                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
                                <div
                                    className="spinner-border text-primary"
                                    role="status"
                                    style={{ width: "3rem", height: "3rem" }}
                                >
                                    <span className="visually-hidden">Loading…</span>
                                </div>
                            </div>
                        </div>
                    </section>
                ) : error ? (
                    /* ==================== ERROR BELOW BANNER ==================== */
                    <section className="py-5 bg-light">
                        <div className="container">
                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
                                <div className="alert alert-danger text-center p-4" style={{ maxWidth: "500px" }}>
                                    <h4>Oops! Something went wrong.</h4>
                                    <p>{error}</p>
                                </div>
                            </div>
                        </div>
                    </section>
                ) : (

                    <>
                        {/* ==================== ABOUT US SECTION ==================== */}
                        <section className="about-section about-page">
                            <div className="container">

                                <div className="row align-items-center">
                                    {/* ---- LEFT: Dynamic "About Us" text (id="1") ---- */}
                                    <div className="col-lg-6 mb-3">
                                        <h2 className="mb-4">About Us</h2>

                                        {/* ---- DYNAMIC CONTENT FROM API ---- */}
                                        {aboutUsContent ? (
                                            <div
                                                className="mt-4"
                                                dangerouslySetInnerHTML={renderHtml(aboutUsContent.content)}
                                            />
                                        ) : (
                                            <p className="text-muted">No content available.</p>
                                        )}

                                    </div>

                                    {/* ---- RIGHT: Image ---- */}
                                    <div className="col-lg-6 text-center">
                                        <img src="/assets/img/aboutus/about-us-image.jpg" alt="About Us" />
                                    </div>
                                </div>

                            </div>
                        </section>

                        {/* ==================== COMPANY MISSION SECTION ==================== */}
                        <section className="company-mission">
                            <div className="container">
                                <div className="row align-items-center">
                                    {/* ---- LEFT: Image ---- */}
                                    <div className="col-lg-6 mb-4 mb-lg-0">
                                        <div className="mission-image rounded-4 overflow-hidden shadow-sm">
                                            <img src="/assets/img/aboutus/company-mission.jpg" alt="Company Mission" />
                                        </div>
                                    </div>

                                    {/* ---- RIGHT: Mission text + dynamic (id="2") ---- */}
                                    <div className="col-lg-6">
                                        <div className="mission-text">
                                            <h2 className="mb-3">Company Mission</h2>

                                            {/* DYNAMIC CONTENT FROM API */}
                                            {missionContent ? (
                                                <div
                                                    dangerouslySetInnerHTML={renderHtml(missionContent.content)}
                                                />
                                            ) : (
                                                <p className="text-muted">No mission statement available.</p>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </>
                )}
            </>
        </div>
    )
}

export default AboutUs